import { render, staticRenderFns } from "./ModalPadrao.vue?vue&type=template&id=5a99af20&scoped=true&"
import script from "./ModalPadrao.vue?vue&type=script&lang=js&"
export * from "./ModalPadrao.vue?vue&type=script&lang=js&"
import style0 from "./ModalPadrao.vue?vue&type=style&index=0&id=5a99af20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a99af20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VIcon,VLayout,VSpacer})
